import { styled } from '@linaria/react';
export interface IStyledLandingSection {
  bg?: string;
}
export const StyledLandingSection = /*#__PURE__*/styled("section")({
  name: "StyledLandingSection",
  class: "s19ty74y",
  vars: {
    "s19ty74y-0": [props => props.bg || 'var(--clr-bg-noise)']
  }
});

require("./LandingSection.linaria.module.css!=!../../../../../../node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./LandingSection.tsx");